import api from './api';

export type PlatformIdentityStatus = 'ACTIVE' | 'INACTIVE' | 'LOCKED' | 'RETIRED';

export interface PlatformIdentity {
  id: number;
  username: string;
  displayName: string;
  email: string | null;
  authProvider: string;
  userStatus: PlatformIdentityStatus;
  mfaRequired: boolean;
  mustChangePassword: boolean;
  siteMembershipCount: number;
  activeSiteMembershipCount: number;
  lastLoginAt: string | null;
  createdAt: string;
}

export interface CreatePlatformIdentityPayload {
  username: string;
  displayName: string;
  email?: string | null;
  temporaryPassword: string;
}

interface Envelope<T> {
  success: boolean;
  data: T;
}

export const platformIdentityApi = {
  listIdentities: (search?: string) =>
    api
      .get<Envelope<PlatformIdentity[]>>('/platform/identities', {
        params: search ? { search } : undefined,
      })
      .then((response) => response.data.data),

  createIdentity: (payload: CreatePlatformIdentityPayload) =>
    api
      .post<Envelope<PlatformIdentity>>('/platform/identities', payload)
      .then((response) => response.data.data),
};

export default platformIdentityApi;
